import { createSelector } from 'reselect';

export const selectUserProfile = (state) => state?.accounts?.userProfile || {};
export const selectUserState = createSelector(
    selectUserProfile,
    (userProfile) => userProfile?.userState || '0'
);
export const selectRewardsTier = createSelector(
    selectUserProfile,
    (userProfile) => userProfile?.rewardsTier || ''
);
